import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero__container">
        <h1 className="hero__title">Saad Lakdawala</h1>
        <p className="hero__subtitle">
          I build features that scale and write tests that actually matter.
        </p>
      </div>
    </section>
  );
};

export default Hero;
